var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFollowers = function SvgFollowers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.852 5.245a2.279 2.279 0 1 0 0-4.557 2.279 2.279 0 0 0 0 4.557M5.5 11.625H.75v-.494a4.11 4.11 0 0 1 4.287-4.063 4.1 4.1 0 0 1 1.96.605M13 10.844H7.927M9.833 12.75l-1.906-1.906 1.906-1.906"
  }))));
};
export default SvgFollowers;